import { render, staticRenderFns } from "./tarsList.vue?vue&type=template&id=4943b588&scoped=true&"
import script from "./tarsList.vue?vue&type=script&lang=js&"
export * from "./tarsList.vue?vue&type=script&lang=js&"
import style0 from "./tarsList.vue?vue&type=style&index=0&id=4943b588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4943b588",
  null
  
)

export default component.exports